"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EyeOpen = EyeOpen;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

function EyeOpen(props) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _core.jsx)("path", {
    d: "M3.118 12.467a.987.987 0 010-.935C5.01 8.033 8.505 5 12 5s6.99 3.033 8.882 6.533a.987.987 0 010 .935C18.99 15.967 15.495 19 12 19s-6.99-3.033-8.882-6.533v0z",
    stroke: "#A5AEA7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), (0, _core.jsx)("path", {
    d: "M14.121 9.879A3 3 0 119.88 14.12a3 3 0 014.24-4.24",
    stroke: "#A5AEA7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

EyeOpen.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "EyeOpen"
};